export enum BlogPostStatus {
	DRAFT = "Brouillon",
	READY_TO_GENERATE = "Prêt à générer",
	READY_TO_REVIEW = "Prêt pour révision",
	READY_TO_PUBLISH = "Prêt à publier",
	PUBLISHED = "Publié",
};
